import React, { ReactNode } from 'react';
import { Wrapper, Button } from './elements';
import { ICON } from 'resources/constants';

type Props = {
  readonly className?: string;
  readonly buttonText: string;
  readonly backOnClick: () => void;
  readonly children: ReactNode;
};

function SecondaryPage({
  className,
  buttonText,
  backOnClick,
  children,
}: Props): React.ReactElement {
  return (
    <Wrapper className={className}>
      <Button icon={ICON.keyboardArrowLeft} onClick={backOnClick}>
        {buttonText}
      </Button>
      {children}
    </Wrapper>
  );
}

export default SecondaryPage;
